import BaseModel from '../BaseModel';

export default class Notification extends BaseModel {
  static entity = 'notifications';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      type: this.attr(null),
      notifiableType: this.attr(null),
      notifiableId: this.attr(null),
      record: this.attr(null),
      read: this.boolean(false),
      readAt: this.attr(null),
      name: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      async markAsRead(id) {
        return this.post(`notifications/${id}/mark-as-read`);
      },
      async getUserNotifications() {
        return this.get('users/notifications');
      },
    },
  }
}
